import { fromJS } from 'immutable';
import { ENSURE_CARDS, GET_ALL_CARDS, SET_ALL_CARDS, SET_CARDS } from './constants';

export const ensureCardsLoaded = () => ({ type: ENSURE_CARDS });

export const getAllCards = () => ({ type: GET_ALL_CARDS });

export const setAllCards = (cards) => ({
  type: SET_ALL_CARDS,
  payload: fromJS({ cards }),
});

export const setCards = (cards) => ({
  type: SET_CARDS,
  payload: fromJS({ cards }),
});
